@import "/src/variables/color";

.brandIcon {
  display: inline-block;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  background-color: $Brand-Primary;

  -webkit-mask-image: var(--zv-icon-src);
  mask-image: var(--zv-icon-src);
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
}
